import {ACTION_TYPE} from "utils/constants";

export const addObject = obj => ({
  type: ACTION_TYPE.ADD_OBJECT,
  payload: obj,
});

export const deleteObject = () => ({
  type: ACTION_TYPE.DELETE_OBJECT,
  payload: undefined,
});

export const copyObject = () => ({
  type: ACTION_TYPE.COPY_OBJECT,
  payload: undefined,
});

export const selectObject = (editId, uuid, target) => ({
  type: ACTION_TYPE.SELECT_OBJECT,
  payload: {editId, uuid, target},
});

export const unselectObject = () => ({
  type: ACTION_TYPE.UNSELECT_OBJECT,
});

export const addScene = scene => ({
  type: ACTION_TYPE.ADD_SCENE,
  payload: scene,
});

export const objectAdded = obj => ({
  type: ACTION_TYPE.OBJECT_ADDED,
  payload: obj,
});

export const reorderObject = info => ({
  type: ACTION_TYPE.REORDER_OBJECT,
  payload: info,
});

export const concealObject = info => ({
  type: ACTION_TYPE.CONCEAL_OBJECT,
  payload: info,
});

export const revealObject = info => ({
  type: ACTION_TYPE.REVEAL_OBJECT,
  payload: info,
});

export const addGUI = info => ({
  type: ACTION_TYPE.ADD_GUI,
  payload: info,
});

export const addAdBanner = info => ({
  type: ACTION_TYPE.ADD_AD_BANNER,
  payload: info,
});

export const changeProperty = info => ({
  type: ACTION_TYPE.CHANGE_PROPERTY,
  payload: info,
});

export const changePropertyFromScene = obj => ({
  type: ACTION_TYPE.CHANGE_PROPERTY_FROM_SCENE,
  payload: obj,
});

export const changeScript = (code, json) => ({
  type: ACTION_TYPE.CHANGE_SCRIPT,
  payload: {code, json},
});

export const saveFile = name => ({
  type: ACTION_TYPE.SAVE_FILE,
  payload: name,
});

export const loadFile = name => ({
  type: ACTION_TYPE.LOAD_FILE,
  payload: name,
});

export const loadFromPID = targetPID => ({
  type: ACTION_TYPE.LOAD_FROM_PID,
  payload: targetPID,
});

export const uploadFile = action => ({
  type: ACTION_TYPE.UPLOAD_FILE,
  payload: action,
});

export const saveProject = name => ({
  type: ACTION_TYPE.SAVE_PROJECT,
  payload: name,
});

export const loadGlb = () => ({
  type: ACTION_TYPE.LOAD_GLB,
  payload: undefined,
});

export const exportGlb = () => ({
  type: ACTION_TYPE.EXPORT_GLB,
  payload: undefined,
});
